module.exports = __webpack_public_path__ + "LGFabout-11.8175d341.png";